import { css } from '@/styled-system/css';

export const listingName = css({
  margin: 0,
  fontWeight: 'bold',
  fontSize: 'md',
  color: 'hpxBlue600',
  paddingTop: '3x',
  paddingLeft: '2x',
  paddingRight: '2x',
});

export const formContainer = css({
  display: 'flex',
  flexDirection: 'column',
  gap: '10px',
  md: {
    gap: '2x',
  },
});

export const fieldGroup = css({
  display: 'flex',
  flexDirection: 'column',
  gap: '4px',
  md: {
    gap: '1x',
  },
});

export const fieldLabel = css({
  fontSize: 'sm',
  fontWeight: 'bold',
  color: 'hpxBlue600',
});

export const requiredIndicator = css({
  color: 'hpxRed400',
  marginLeft: '2px',
});

export const textInput = css({
  width: '100%',
  maxWidth: '100%',
  boxSizing: 'border-box',
  WebkitAppearance: 'none',
  appearance: 'none',
  textAlign: 'left',
  paddingLeft: '12px',
  paddingRight: '12px',
  paddingTop: '8px',
  paddingBottom: '8px',
  height: '40px',
  fontSize: 'md',
  color: 'hpxBlue500',
  borderWidth: '1px',
  borderStyle: 'solid',
  borderColor: 'hpxGrey400',
  borderRadius: '4px',
  outline: 'none',
  backgroundColor: 'hpxWhite',
  transitionProperty: 'border-color, box-shadow',
  transitionDuration: '0.15s',
  transitionTimingFunction: 'ease',
  md: {
    height: '44px',
    paddingTop: '10px',
    paddingBottom: '10px',
  },
  _focusVisible: {
    borderColor: 'hpxTeal500',
    boxShadow: '0 0 0 2px rgba(0, 122, 112, 0.15)',
  },
  _placeholder: {
    color: 'hpxGrey500',
  },
  '&::-webkit-date-and-time-value': {
    textAlign: 'left',
  },
});

export const textInputError = css({
  borderColor: 'hpxRed400',
  _focusVisible: {
    borderColor: 'hpxRed400',
    boxShadow: '0 0 0 2px rgba(201, 58, 26, 0.15)',
  },
});

export const textarea = css({
  width: '100%',
  paddingLeft: '12px',
  paddingRight: '12px',
  paddingTop: '10px',
  paddingBottom: '10px',
  fontSize: 'md',
  color: 'hpxBlue500',
  borderWidth: '1px',
  borderStyle: 'solid',
  borderColor: 'hpxGrey400',
  borderRadius: '4px',
  outline: 'none',
  resize: 'vertical',
  minHeight: '80px',
  md: {
    minHeight: '120px',
  },
  fontFamily: 'inherit',
  transitionProperty: 'border-color, box-shadow',
  transitionDuration: '0.15s',
  transitionTimingFunction: 'ease',
  _focusVisible: {
    borderColor: 'hpxTeal500',
    boxShadow: '0 0 0 2px rgba(0, 122, 112, 0.15)',
  },
  _placeholder: {
    color: 'hpxGrey500',
  },
});

export const selectInput = css({
  width: '100%',
  paddingLeft: '12px',
  paddingRight: '12px',
  paddingTop: '8px',
  paddingBottom: '8px',
  height: '40px',
  fontSize: 'md',
  color: 'hpxBlue500',
  borderWidth: '1px',
  borderStyle: 'solid',
  borderColor: 'hpxGrey400',
  borderRadius: '4px',
  outline: 'none',
  backgroundColor: 'hpxWhite',
  cursor: 'pointer',
  transitionProperty: 'border-color, box-shadow',
  transitionDuration: '0.15s',
  transitionTimingFunction: 'ease',
  md: {
    height: '44px',
    paddingTop: '10px',
    paddingBottom: '10px',
  },
  _focusVisible: {
    borderColor: 'hpxTeal500',
    boxShadow: '0 0 0 2px rgba(0, 122, 112, 0.15)',
  },
});

export const fieldError = css({
  fontSize: 'tiny',
  color: 'hpxRed400',
  marginTop: '2px',
});

export const formError = css({
  fontSize: 'sm',
  color: 'hpxRed400',
  padding: '1x',
  backgroundColor: 'hpxRed100',
  borderRadius: '4px',
});

export const fieldsetGroup = css({
  borderWidth: '0',
  padding: '0',
  margin: '0',
  display: 'flex',
  flexDirection: 'column',
  gap: '2x',
});

export const legendText = css({
  fontSize: 'sm',
  fontWeight: 'bold',
  color: 'hpxBlue600',
  marginBottom: '1x',
});

export const bedsAndBathsRow = css({
  display: 'grid',
  gridTemplateColumns: '1fr 1fr',
  gap: '10px',
  md: {
    gap: '2x',
  },
});

export const emailPhoneRow = css({
  display: 'grid',
  gridTemplateColumns: '1fr 1fr',
  gap: '10px',
  md: {
    gap: '2x',
  },
});

export const checkboxRow = css({
  display: 'flex',
  alignItems: 'flex-start',
  gap: '1x',
});

export const checkboxInput = css({
  marginTop: '3px',
  width: '18px',
  height: '18px',
  accentColor: 'hpxTeal500',
  cursor: 'pointer',
  flexShrink: 0,
});

export const checkboxLabel = css({
  fontSize: 'sm',
  color: 'hpxBlue500',
  lineHeight: '20px',
});

export const formFooter = css({
  flexShrink: 0,
  display: 'flex',
  flexDirection: 'column',
  gap: '2x',
  bg: 'hpxWhite',
  paddingTop: '2x',
  paddingBottom: 'calc(16px + env(safe-area-inset-bottom, 0px))',
  marginBottom: '1x',
  paddingLeft: '2x',
  paddingRight: '2x',
  borderTopWidth: '1px',
  borderTopStyle: 'solid',
  borderTopColor: 'hpxGrey400',
});

export const mailcheckHintButton = css({
  fontSize: 'tiny',
  color: 'hpxTeal500',
  cursor: 'pointer',
  textDecoration: 'underline',
  background: 'none',
  borderWidth: '0',
  padding: '0',
  textAlign: 'left',
  _hover: {
    color: 'hpxTeal600',
  },
  _focusVisible: {
    outlineWidth: '2px',
    outlineStyle: 'solid',
    outlineColor: 'hpxTeal500',
    outlineOffset: '2px',
  },
});

export const disclaimer = css({
  fontSize: 'tiny',
  color: 'hpxGrey600',
  lineHeight: '16px',
});

export const disclaimerLink = css({
  color: 'hpxTeal500',
  textDecoration: 'underline',
  _hover: {
    color: 'hpxTeal600',
  },
});

export { visuallyHidden as srOnly } from 'app/shared/halo/styles/visuallyHidden';
